import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin, Tabs } from "antd";
import {
  configAttrUser,
  fetchRoles,
  getAttrUser,
} from "../../API/api";
import MultiSelectCM from "../MultiSelectCm/MultiSelectCm";
import { FloatButton } from "antd";
import EditRoleExpert from "./EditRoleExpert";
import EditRoleCM from "./EditRoleCM";
import EditRoleAdmin from "./EditRoleAdmin";
import EditRoleSeeker from "./EditRoleSeeker";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
const submitRatingSuccessToast = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export default function EditUserRole() {
  const dispatch= useDispatch();
  const { selectedUser, userTypeList } = useSelector(
    (state) => state.manageUsers
  );
  const [currentTab, setCurrentTab] = useState(0);
  const state = useSelector((state) => state.manageUsers);
  const [userAttr, setUserAttr] = useState(null);
  const {drawerOpenMU,reloadMU} = bindActionCreators(Actions, dispatch)
  const [isLoading, setIsLoading] = useState(true);
  const [usertype, setUserType] = useState(
    userTypeList.filter((obj) => obj.id === selectedUser.userType)[0]
  );
  const [currentrole, setCurrentrole] = useState(
    selectedUser.roles.length === 0
      ? []
      : selectedUser.roles.filter((obj) => {
          obj.name = obj.roleName;
          obj.label = obj.roleName;
          obj.value = obj.roleId;
          return obj;
        })
  );

  const onChangeUserType = (e) => {
    setUserType(e);
  };
  const onChangeRoles = (e) => {
    let newResp ={
      attributes:{},
      userId:userAttr.userId
    }
    if(userAttr.blackoutPeriod !== undefined){
      newResp.blackoutPeriod = userAttr.blackoutPeriod;
    }
    if(userAttr.expertScoreAllowed !== undefined){
      newResp.expertScoreAllowed = userAttr.expertScoreAllowed;
    }
    if(userAttr.seekerIdentity !== undefined){
      newResp.seekerIdentity = userAttr.seekerIdentity;
    }
    e.filter(es=>{
      if(userAttr.attributes[es.roleId]===undefined){
        newResp.attributes[es.roleId]={
          routingLevels:{}
        }
        // if(es.roleName==='Expert'){
        //   newResp.blackoutPeriod = {};
        // }
      }
      if(Object.keys(userAttr.attributes).includes(es.roleId.toString())){
        newResp.attributes[es.roleId] = userAttr.attributes[es.roleId]
      }
    })
    setCurrentrole(e);
    setUserAttr(newResp);
  };
  const filterUserType = (arr) => {
    arr.filter((obj) => {
      obj.name = obj.typeName;
      obj.label = obj.typeName;
      obj.value = obj.id;
      return obj;
    });
    return arr;
  };
  const [roles, setRoles] = React.useState([]);
  const getRoles = () => {
    setIsLoading(true);
    getAttrUser(state.selectedUser.userUuid).then((res) => {
      if (res.data.success) {
        Object.keys(res.data.data.attributes).filter(at=>{
          if(res.data.data.attributes[at].cmDomains !== undefined){
            if(res.data.data.attributes[at].cmDomains[0]===null){
              res.data.data.attributes[at].cmDomains.shift();
            }
           }
          if(res.data.data.attributes[at].domains !== undefined){
            if(res.data.data.attributes[at].domains[0]===null){
              res.data.data.attributes[at].domains.shift();
            }
            // res.data.data.attributes[at].domains = filterdm;
          }
        })
        setUserAttr(res.data.data);
        fetchRoles()
          .then((res) => {
            let newArr = res.data.data.filter((role) => {
              if (role.active) {
                role.name = role.roleName;
                role.label = role.roleName;
                role.value = role.roleId;
                return role;
              }
            });
            setRoles(newArr);
            setIsLoading(false);
            setCurrentTab(1);
          })
          .catch((err) => console.log(err));
      }
    });
  };
  const onChangeExpertData=(data)=>{
    console.log(data);
  }
  const onChangeCMData=(data)=>{
    console.log(data);
  }
  const onChangeAdminData=(data)=>{
    console.log(data);
  }
  const onChangeSeekerData=(data)=>{
    console.log(data);
  }
  const assignContentFunc = (role, id) => {
    switch (role) {
      case "Admin":
        return <EditRoleAdmin data={userAttr} onChangeFunc={onChangeAdminData} roleId={id}  />;
      case "Seeker":
        return <EditRoleSeeker data={userAttr} onChangeFunc={onChangeSeekerData} roleId={id}  />;
      case "Expert":
        return <EditRoleExpert data={userAttr} onChangeFunc={onChangeExpertData} roleId={id}  />;
      case "CM":
        return <EditRoleCM data={userAttr} onChangeFunc={onChangeCMData} roleId={id}  />;
      default:
        return null;
    }
  };
  const manageTabData = (arr) => {
    arr.filter((obj) => {
      obj.key = obj.roleId;
      obj.label = obj.roleName;
      obj.children = assignContentFunc(obj.roleName, obj.roleId);
      obj.disabled = obj.roleName === "Emails" ? true : false;
    });
    return arr;
  };
  
  const onSubmit = () => {
    if(userAttr.blackoutPeriod !== undefined){
      if(userAttr.blackoutPeriod.blackoutTimezone === undefined || userAttr.blackoutPeriod.blackoutTimezone ===''){
        toast.error(submitRatingSuccessToast('Please select timezone for working hours.'), {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if(userAttr.blackoutPeriod.workTimings === undefined || Object.keys(userAttr.blackoutPeriod.workTimings).length === 0){
        toast.error(submitRatingSuccessToast('Please add working hours for selected timezone.'), {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }
    if(userAttr.attributes !== undefined){
      const hasUnconfiguredAlertTimezone = Object.values(userAttr.attributes).some(
        (attr) =>
          attr.expiredQuestionAlert !== undefined &&
          attr.expiredQuestionAlert.enabled &&
          (attr.expiredQuestionAlert.timezone === undefined ||
            attr.expiredQuestionAlert.timezone === null ||
            attr.expiredQuestionAlert.timezone === ''),
      );
      if(hasUnconfiguredAlertTimezone){
        toast.error(submitRatingSuccessToast('Please select a timezone for the CM email alert.'), {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }
    userAttr.userType = usertype.value;
    setIsLoading(true);
    configAttrUser(userAttr).then(res=>{
      if(res===undefined) return;
        if(res.data.success){
          reloadMU(Math.random()*10);
          drawerOpenMU(0);
          toast.success(submitRatingSuccessToast(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
    });
  };
  useEffect(() => {
    getRoles();
  }, []);
  return (
    <>
      {isLoading && (
        <div style={{ textAlign: "center", marginTop: "50%" }}>
          <Spin size="large" />
        </div>
      )}
      {!isLoading && (
        <div>
          <div className="mt-3" style={{display:'flex',justifyContent:'space-between'}}>
            <div>
            <h1 style={{ fontSize: "22px" }}>
              Edit User Details{" "}
              <span
                style={{ fontSize: "22px", fontWeight: "100" }}
              >{`(${selectedUser.firstName} ${selectedUser.lastName})`}</span>
            </h1>
            </div>
            <div>
            <button style={{border:'1px solid var(--light_color_shade)',cursor:'pointer', color:'#fff',background:'var(--light_color_shade)',borderRadius:'4px', paddingInline:'10px',paddingBlock:'5px'}} onClick={()=>onSubmit()}>Save</button>
            </div>
          </div>
          <hr className="mt-3 mb-3" />
          <div className="mb-3" style={{ display: "flex", flexWrap: "wrap" }}>
            <div
              className="mt-1"
              style={{
                display: "flex",
                alignItems: "baseline",
                marginRight: "20px",
              }}
            >
              <div
                style={{
                  marginRight: "10px",
                  fontSize: "14px",
                  // fontWeight: "00",
                }}
              >
                Roles
              </div>
              <div>
                <MultiSelectCM
                  onChangeFunc={onChangeRoles}
                  options={roles}
                  isMulti={true}
                  value={currentrole}
                />
              </div>
            </div>
            <div
              className="mt-1"
              style={{ display: "flex", alignItems: "baseline" }}
            >
              <div
                style={{
                  marginRight: "10px",
                  fontSize: "14px",
                  // fontWeight: "100",
                }}
              >
                User Type
              </div>
              <div>
                <MultiSelectCM
                  onChangeFunc={onChangeUserType}
                  isMulti={false}
                  value={usertype}
                  options={filterUserType(userTypeList)}
                />
              </div>
            </div>
          </div>
          <div>
            <Tabs
              size="large"
              // defaultActiveKey="1"
              value={currentTab}
              items={manageTabData(currentrole)}
              onChange={(e) => setCurrentTab(e)}
            />
          </div>
          {/* <div>
            <FloatButton
              description="Save"
              onClick={() => onSubmit()}
              style={{ width: "80px" }}
              type="primary"
              shape="square"
            />
          </div> */}
        </div>
      )}
    </>
  );
}
